module.exports = __webpack_public_path__ + "static/media/500Error.a4df9d3a.svg";